import { AppContext } from "@/App.context";
import config from "@/config";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import {
  API_LOADING_ERROR,
  API_NOT_FOUND_ERROR,
  ERROR_STATUS_CODES,
  API_NO_DATA_FOUND_ERROR,
} from "@/lib/errors/error-constants";

/**
 * @typedef GetCountRes[]
 * @property {number} id
 * @property {string} name
 * @property {boolean} active
 */

export const getSeetingData = (token) => {
  /**
   * @returns {Promise<GetCountRes>}
   */

  return async (signal) => {
    const count = await fetch(`${config.apiHost}/v1/settings/get-settings`, {
      method: "GET",
      body: JSON.stringify(),
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      signal,
    });
    if (!count.ok) {
      if (ERROR_STATUS_CODES.includes(count.status)) {
        throw new Error(API_LOADING_ERROR);
      }
      if (count.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR);
      }
      throw new Error((await count.json()).message);
    }

    const data = await count.json();

    if (data?.data?.settings?.length === 0) {
      throw new Error(API_NO_DATA_FOUND_ERROR);
    }
    return data;
  };
};

/**
 * @param {any[]=} deps
 */
export const useSettingData = (deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getSeetingData", ...deps],
    queryFn: ({ signal }) => getSeetingData(appContext.idToken)(signal),
  });
  return query;
};
